import "./App.css.js?css";
export const error = 'sz9w3a1 sz9w3a0';
export const fallback = 'sz9w3a0';